import React from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import { compose, lifecycle, withHandlers, withProps, withState } from 'recompose'
import { connect } from 'react-redux'
import { fetchingState } from '../helpers/hocs'
import { bindActionCreators } from 'redux'
import { get as getFeedback, send as sendFeedback } from '../store/reducers/feedback'
import Loader from './../components/Loader'
import { FormattedMessage, injectIntl } from 'react-intl'
import validator from 'email-validator'
import { checkLogin, checkEmail, checkPhone, checkPhoneFund, checkDateFormat, checkINN, checkURL } from './../containers/Signin'
import { fundForm } from '../store/reducers/funds/list'
import Textarea from 'react-textarea-autosize'
import Input from './../components/Input'

import * as _ from 'recompose'
import { isEmpty } from 'ramda'
import Link from './../components/Link'
import { sendMindbox } from '../helpers/hocs'
import { getLoggedUser } from '../selectors/user'


var success = false

const Connect = ({ data, fetching, formOpened, setFormState, intl,
  success = null, errors, tmpData, setData, peoceed, currentLocale, submit, bidOverlay, setItem, options, setInput, checkout, error, setDeliveryDate, inputCheck }) => {
  return(
  <div className='Container'>
    
    {!success && (
        <div className='GiftCardsBuy__row-s FundForm'>
          <h1 className='Head GiftCardsBuy__row-xl' ref={instance => this.buyRef = instance}>
          <FormattedMessage id='connect.application'/>
          </h1>
        <div className='FundForm FundForm_stepTitle'><small><FormattedMessage id='connect.subtitle'/></small></div>
        <div className='FundForm FundForm_stepTitle'><b><FormattedMessage id='connect.step'/> 1:</b> <FormattedMessage id='connect.general_information'/></div>

        <Input 
          //style={{border: '1px solid black'}} 
          name='value' 
          onChange = {setInput('value')} 
          errors = {errors} 
          value = {tmpData.value}
          label={'Название фонда'}
          
        />
        <br></br>

        <Input  
          name='webSite' 
          onChange = {setInput('webSite')} 
          errors = {errors} 
          value = {tmpData.webSite}
          label={'Сайт'}
          errorText={'Введите сайт фонда в формате www.domain.name или https://www.domain.name'}
          //startValue={'https://'}
        />

        <br></br>

        <Input  
          name='city' 
          onChange = {setInput('city')} 
          errors = {errors} 
          value = {tmpData.city}
          label={'Город'}
        />

        <br></br>

        <Input  
          name='physAdress' 
          onChange = {setInput('physAdress')} 
          errors = {errors} 
          value = {tmpData.physAdress}
          label={'Физический адрес'}
        />

        <br></br>

        <Input  
          name='email' 
          onChange = {setInput('email')} 
          errors = {errors} 
          value = {tmpData.email}
          label={'Общая эл. почта'}
          errorText={'Укажите эл. почту в формате: example@mail.ru'}
        />

        <br></br>

        <Input  
          name='phone' 
          onChange = {setInput('phone')} 
          errors = {errors} 
          value = {tmpData.phone}
          label={'Общий номер телефона'}
          errorText={'Укажите номер в формате +7ХХХХХХХХХХ'}
          startValue={'+7'}
        />

        <br></br>

        {/*<Input  
          name='instaLink' 
          onChange = {setInput('instaLink')} 
          errors = {errors} 
          value = {tmpData.instaLink}
          label={'Аккаунт в Instagram'}
          startValue={'instagram.com/'}
        />

        <br></br>

        <Input  
          name='facebookPage' 
          onChange = {setInput('facebookPage')} 
          errors = {errors} 
          value = {tmpData.facebookPage}
          label={'Страница в Facebook'}
          startValue={'facebook.com/'}
        />

        <br></br>*/}

        <div className='FundForm FundForm_stepTitle'><b><FormattedMessage id='connect.step'/> 2:</b> <FormattedMessage id='connect.representative'/></div>

        <Input  
          name='contactFirstname' 
          onChange = {setInput('contactFirstname')} 
          errors = {errors} 
          value = {tmpData.contactFirstname}
          label={'Имя представителя'}
        />

        <br></br>

        <Input  
          name='contactLastname' 
          onChange = {setInput('contactLastname')} 
          errors = {errors} 
          value = {tmpData.contactLastname}
          label={'Фамилия представителя'}
        />

        <br></br>

        {/* <Input  
          name='contactMiddlename' 
          onChange = {setInput('contactMiddlename')} 
          errors = {errors} 
          value = {tmpData.contactMiddlename}
          label={'Отчество представителя'}
        />

        <br></br> */}

        <Input  
          name='contactPhone' 
          onChange = {setInput('contactPhone')} 
          errors = {errors} 
          value = {tmpData.contactPhone}
          label={'Номер телефона представителя'}
          errorText={'Укажите номер в формате +7ХХХХХХХХХХ'}
          startValue={'+7'}
        />

        <br></br>

        <Input  
          name='contactEmail' 
          onChange = {setInput('contactEmail')} 
          errors = {errors} 
          value = {tmpData.contactEmail}
          label={'Эл. почта представителя'}
          errorText={'Укажите эл. почту в формате: example@mail.ru'}
        />

        <br></br>

        <div className='FundForm FundForm_stepTitle'><b><FormattedMessage id='connect.step'/> 3:</b> <FormattedMessage id='connect.entity'/></div>

        <Input  
          name='fullJurName' 
          onChange = {setInput('fullJurName')} 
          errors = {errors} 
          value = {tmpData.fullJurName}
          label={'Полное юр. название'}
        />

        <br></br>

        <Input  
          name='years' 
          onChange = {setInput('years')} 
          errors = {errors} 
          value = {tmpData.years}
          label={'Дата основания'}
          errorText={'Введите дату в формате ДД.ММ.ГГГГ'}
          placeholder={'ДД.ММ.ГГГГ'}
        />

        <br></br>

        <Input  
          name='jurAdress' 
          onChange = {setInput('jurAdress')} 
          errors = {errors} 
          value = {tmpData.jurAdress}
          label={'Юридический адрес'}
        />

        <br></br>

        <Input  
          name='inn' 
          onChange = {setInput('inn')} 
          errors = {errors} 
          value = {tmpData.inn}
          label={'ИНН'}
          errorText={'Введите корректный ИНН'}
        />

        <br></br>

        <Input  
          name='directorFirstname' 
          onChange = {setInput('directorFirstname')} 
          errors = {errors} 
          value = {tmpData.directorFirstname}
          label={'Имя директора фонда'}
        />

        <br></br>

        <Input  
          name='directorLastname' 
          onChange = {setInput('directorLastname')} 
          errors = {errors} 
          value = {tmpData.directorLastname}
          label={'Фамилия директора фонда'}
        />

        <Input  
          name='directorEmail' 
          onChange = {setInput('directorEmail')} 
          errors = {errors} 
          value = {tmpData.directorEmail}
          label={'Эл. почта директора фонда'}
          errorText={'Укажите эл. почту в формате: example@mail.ru'}
        />

        <br></br>

        {/* <Input  
          name='directorMiddlename' 
          onChange = {setInput('directorMiddlename')} 
          errors = {errors} 
          value = {tmpData.directorMiddlename}
          label={'Отчество директора фонда'}
        />

        <br></br> */}

        <div className='FundForm FundForm_stepTitle'><b><FormattedMessage id='connect.step'/> 4:</b> <FormattedMessage id='connect.suggested_lots'/></div>

        <Input
          type='textarea'
          name='suggestedLots' 
          onChange = {setInput('suggestedLots')} 
          errors = {errors} 
          value = {tmpData.suggestedLots}
          label={'Перечислите ваши лоты в формате: ФИО, компания, должность - ссылка'}
          minRows={10}
          isTextarea
        />

        <br></br>

        <div className='FundForm FundForm_agreement'>
          <input type='checkbox' className='FundForm_checkbox' name='offerCheckbox' onChange={inputCheck(this)} />
          <span className='FundForm_offer'>
            Отправляя анкету на рассмотрение, я принимаю условия
            {' '}
            <a href='/offer' target='_blank' rel='noopener noreferrer' style={{color: 'red', textDecoration: 'underline'}}>Пользовательского соглашения,</a>
            {' '}
            <a href='/assets/files/docs/05.pdf' target='_blank' rel='noopener noreferrer' style={{color: 'red', textDecoration: 'underline'}}>Программы Meet For Charity</a>
            {' '}
            и соглашаюсь с
            {' '}
            <a href='/policy' target='_blank' rel='noopener noreferrer' style={{color: 'red', textDecoration: 'underline'}}>Политикой конфиденциальности</a>
          </span>
        </div>
        
        {errors && errors.offerCheckbox && <span style={{color: "red"}}><small>Необходимо согласиться с условиями</small></span>}
        <br></br>

        {!isEmpty(errors) && <div className='FundForm_errorBlock'>
          <div className='FundForm_line'>
            <div className='FundForm_errorBlock_icon'><img src='/assets/img/warning_icon.svg'/></div>
            <div className='FundForm_errorBlock_text'><FormattedMessage id='connect.have_errors'/></div>
          </div>
        </div>}
        
        <button className='Button FundForm_sendButton' onClick={submit}>
          <FormattedMessage id='connect.send'/>
        </button>
        
        
        </div>
      )}
      {success && (
        <div className='GiftCardsBuy__row-s FundForm'> 
            <h1 className='FundForm_congrat'><b><FormattedMessage id='connect.thanks_for'/></b></h1>
            <div className='FundForm FundForm_congratText'><FormattedMessage id='connect.we_contact'/></div>
            <Link to='/'>
              <div className='Button Button_regButton_success'>
                <FormattedMessage id='connect.go_main'/>
              </div>
            </Link>
        </div>
      )}
      </div>
      
      

)}

const mapStateToProps = state => ({
  ...state.contacts,
  user: getLoggedUser(state),
  currentLocale: state.intl.locale,
  ...state.feedback, ...state.giftcards, ...state.pay
})

const mapDispatchToProps = dispatch => bindActionCreators({ fundForm }, dispatch)

export default injectIntl(compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('formOpened', 'setFormState', false),
  //withState('data', 'setData', {}),
  withState('tmpData', 'setTmpData', {}),
  withState('success', 'setSuccess', null),
  withState('errors', 'setErrors', {}),//ошибки заполнения формы
  withState('error', 'setError', ''),//ошибки при процессе покупки
  fetchingState({ multi: true }),
  withHandlers({
    inputCheck: ({ setTmpData, tmpData }) => field => e => {console.log('e.target.name', e.target.name, e.target.checked)
      if (e.target.name == 'isWhite'){
        tmpData['isOrange'] = false//(e.target.checked)
        setTmpData(tmpData)
      } else if (e.target.name == 'isOrange') {
        tmpData['isOrange'] = true
        setTmpData(tmpData)
      } else {
        tmpData[e.target.name] = e.target.checked
        setTmpData(tmpData)
        console.log(tmpData);
      }
    },
    setDeliveryDate: ({ setTmpData, tmpData, /*data, setData*/ }) => field => value => {
      tmpData.deliveryDate = value
      setTmpData(tmpData)
    },
    setInput: ({ setTmpData, tmpData }) => field => e => {//запись данных при записи в input
      if (field == 'text') {//условие - не более 300 символов
        tmpData[field] = e.target.value.substring(0, 300)
      } else if (field == "denomination") {
        tmpData["denominationString"] = e.target.value.replace(/\s/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        tmpData[field] = Number(e.target.value.replace(/\s/g, ''))
      } else {
        tmpData[field] = e.target.value
      }
      setTmpData(tmpData)
    },
    setData: ({ setTmpData, tmpData }) => field => e => {
      tmpData[field] = e
      setTmpData(tmpData)
    },
    /*clearData: ({ setData }) => () => {
      //setData({})
      setTmpData(tmpData)
    },*/
    peoceed: ({ /*setData, data,*/ setTmpData, tmpData, options }) => (field, e) => {//запись данных при выборе в select
      e && e.preventDefault && e.preventDefault()
      if (field == 'denomination') {
        tmpData[field] = options.optionsArray[e]
        setTmpData(tmpData)
      } else {
        tmpData[field] = e
        setTmpData(tmpData)
      }
    },
    setItem: ({ /*setData, data,*/ setTmpData, tmpData, options }) => (value, field) => () => {//выбор из двух item (тип карты, фикс/нефиксированная, дата доставки)
      if (field == "isFixed") {
        setTmpData({ ...tmpData, [field]: value, 'denomination': null })
        //data.denomination = null
      } else {
        setTmpData({ ...tmpData, [field]: value })
      }
    },
    submit: ({ tmpData, /*data,*/ setSuccess, fetchingWrap, sendForm, setErrors, fundForm, setError, setFormState, user }) => async e => {//отправка данных на сервер
      e && e.preventDefault()
      setSuccess(null)

      let data = { ...tmpData }
      data.info = []
      data.info[0] = {
        locale: "ru",
        value: data.value
      }
      data.information = {
        phone: data.phone? data.phone.replace(/\D/g, '') : null,
        email: data.email,
        jurAdress: data.jurAdress,
        physAdress: data.physAdress,
        //instaLink: data.instaLink,
        //facebookPage: data.facebookPage
      }
      data.requisites_structure = {
        title: data.fullJurName,
        inn: data.inn
      }
      data.director = {
        firstname: data.directorFirstname,
        lastname: data.directorLastname,
        email: data.directorEmail,
        //middlename: data.directorMiddlename
      }
      data.contactPersons =[];
      data.contactPersons[0] = {
        firstname: data.contactFirstname,
        lastname: data.contactLastname,
        //middlename: data.contactMiddlename,
        phone: data.contactPhone? data.contactPhone.replace(/\D/g, '') : null,
        email: data.contactEmail
      }
      let errors = {};
      //if (!data.) errors.inp = true
      if (!data.info[0].value) errors.value = true
      if (!data.fullJurName) errors.fullJurName = true
      if (!data.requisites_structure.inn || !checkINN(data.requisites_structure.inn)) errors.inn = true
      if (!data.information.physAdress) errors.physAdress = true
      if (!data.information.jurAdress) errors.jurAdress  = true
      //if (!data.information.instaLink) errors.instaLink  = true
      if (!data.webSite || !checkURL(data.webSite)) errors.webSite = true
      if (!data.city) errors.city = true
      if (!data.director.firstname) errors.directorFirstname = true
      if (!data.director.lastname) errors.directorLastname = true
      //if (!data.director.middlename) errors.directorMiddlename = true
      if (!data.years || !checkDateFormat(data.years)) errors.years = true
      if (!data.contactPersons[0].firstname) errors.contactFirstname = true
      //if (!data.contactPersons[0].middlename) errors.contactMiddlename = true
      if (!data.contactPersons[0].lastname)errors.contactLastname = true
      if (!data.contactPersons[0].phone || !checkPhone(data.contactPhone)) errors.contactPhone = true
      if (!data.contactPersons[0].email || !validator.validate(data.contactPersons[0].email)) errors.contactEmail = true
      if (!data.email || !validator.validate(data.email)) errors.email = true
      if (!data.phone || !checkPhone(data.phone)) errors.phone = true
      if (!data.suggestedLots) errors.suggestedLots = true
      if (data.offerCheckbox != true) errors.offerCheckbox = true
      setErrors(errors)
      if (Object.keys(errors).length === 0) {
        const result = await fundForm(data)

        if (result === 200) {
          let mindboxData
          if (user) {
            mindboxData = {
              customer: {
                email: data.contactEmail,
                lastName: data.contactLastname,
                firstName: data.contactFirstname,
                mobilePhone: data.contactPhone,
                ids: {
                  websiteID: user._id
                },
                customFields: {
                  facebook: data.facebookPage,
                  instagram: data.instaLink,
                  nameFound: data.value,
                  site: data.webSite,
                  city: data.city,
                },
              },
              customerAction: {
                customFields: {
                  emailfond: data.email,
                  phonefond: data.phone,
                  cityfund: data.city,
                  siteFund: data.webSite
                }
              },
              pointOfContact: "meetforcharity-website"
            }
            sendMindbox(mindboxData, 'registrationFundAutorized')
          } else {
            mindboxData = {
              customer: {
                email: data.contactEmail,
                lastName: data.contactLastname,
                firstName: data.contactFirstname,
                mobilePhone: data.contactPhone,
                customFields: {
                  facebook: data.facebookPage,
                  instagram: data.instaLink,
                  nameFound: data.value,
                  site: data.webSite,
                  city: data.city,
                },
              },
              customerAction: {
                customFields: {
                  emailfond: data.email,
                  phonefond: data.phone,
                  cityfund: data.city,
                  siteFund: data.webSite
                }
              },
              pointOfContact: "meetforcharity-website"
            }
            sendMindbox(mindboxData, 'registrationFundNotAutorized')
          }

          setSuccess(true)
          success = true
          setError('')
        } else {
          setSuccess(true)
          setError('Ошибка')
        }
      }
    }
  }),
  lifecycle({
    componentWillMount() {
      //this.props.clearData()
      //this.props.setTmpData()//значения по умолчанию
    },
    componentWillReceiveProps (np) {
      if (np.info && this.props.info && np.info.name != this.props.info.name){
        this.props.setTmpData({giver: np.info.name, giverPhone: np.info.phone, giverEmail: np.info.email, ...this.props.tmpData})
      }
      console.log('пропсы на страницы регистрации фонда**********', np)
    },
    componentWillUnmount() {
      this.props.setTmpData({})
      this.props.setSuccess(null)
      //this.props.clearData()
    }
  }),
)(Connect))



// WEBPACK FOOTER //
// ./src/containers/Connect.jsx